export default __webpack_public_path__ + "static/home-no-code-backstage-f3955978b27092343aa510513f1ac728.svg";